export default "__VITE_ASSET__28ab9309__"